import { render } from "./infoCompletionEdit.vue?vue&type=template&id=6b8cef66"
import script from "./infoCompletionEdit.vue?vue&type=script&lang=js"
export * from "./infoCompletionEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__